(() => {
  const selector = '[data-fit-heading-texture]';
  const supportsObserver = 'IntersectionObserver' in window;

  const reveal = (element) => {
    element.classList.add('is-visible');
    element.dataset.fitHeadingTextureReady = 'true';
  };

  const observer = supportsObserver
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -5% 0px'
        }
      )
    : null;

  const initialize = (scope = document) => {
    const elements = [];
    if (scope instanceof Element && scope.matches(selector)) elements.push(scope);
    scope.querySelectorAll?.(selector).forEach((element) => elements.push(element));

    elements.forEach((element) => {
      if (element.classList.contains('is-visible')) return;
      element.dataset.fitHeadingTextureReady = 'true';
      if (observer) observer.observe(element);
      else reveal(element);
    });
  };

  window.initFitHeadingTexture = initialize;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:select', (event) => initialize(event.target));
})();
